import { IIncentiveParamsNumberOfShows } from "./incentive-params-number-of-shows.interface";

export class IncentiveParamsNumberOfShowsDto
  implements IIncentiveParamsNumberOfShows
{
  //
  show_type: string;
  number_of_shows: number;
  fee: number;
  junior_fee?: number;

  exceptions?: {
    show_element: string;
    level?: string;
    fee: number;
    early_bird_fee?: number;
    junior_fee?: number;
    min_shows?: number;
  }[];
}
